module.exports = __webpack_public_path__ + "img/assets/select/navy@2x.03d6b941a303d248fdc77222921fd9a9.webp";